import React from "react";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography, styled } from "@mui/material";
import WarningIcon from "@icons/myicons/warning-circle-filled.svg?react";

const NoticeIcon = styled(WarningIcon)(({ theme }) => ({
  flex: "none",
  color: theme.palette.warning.main,
  marginRight: theme.spacing(1),
  marginLeft: theme.spacing(-1),
}));

interface Props {
  count: number;
  investmentId: string;
}

export const MissingDividendsNotice = ({ count, investmentId }: Props) => {
  const { t } = useTranslation();

  if (count <= 0) return null;

  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      gap={1}
      data-testid="missing-dividends-container"
    >
      <Box display="flex" alignItems={{ xs: "flex-start", md: "center" }}>
        <NoticeIcon />
        <Typography variant="body1">
          {t("investment.dividends.missingDividends.header", {
            count,
            value: count,
          })}
        </Typography>
      </Box>
      <Button
        variant="text"
        color="primary"
        size="small"
        component={Link}
        to={`/investments/${investmentId}/dividend-wizard/create/batch`}
      >
        {t("investment.dividends.missingDividends.addBatchButton")}
      </Button>
    </Box>
  );
};
